module.exports = __webpack_public_path__ + "img/pendaftaran.ccc096a9.svg";